<template>
  <footer class="footer">
    <div class="container">
      <nav />
      <div class="copyright text-right">
        &copy; {{ new Date().getFullYear() }}
        <a
          href="https://www.green4t.com"
          target="_blank"
        >green4T</a> Available - Efficient - Sustainable
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  imgLogo: {
    type: String,
    default: require("@/assets/img/logo_green4t_bg.png")
  }
};
</script>
<style></style>
